// extracted by mini-css-extract-plugin
export default {"wrapper":"TableFilterTags_wrapper__wRv6D"};